const usato_clienti = {
    state: {
        component: 'Index',
        edit: false,
        all: []
    },
    mutations: {
        CHANGE_USATO_CLIENTI_COMPONENT(state, payload) {
            state.component = payload
        },
        CHANGE_USATO_CLIENTI_EDIT(state, payload) {
            state.edit = payload
        }
    },
    getters: {
        getUsatoClientiComponent: state => state.component,
        getUsatoClientiEdit: state => state.edit
    }
}

export default usato_clienti